import React,{useState} from "react";
import Skin from '../images/Skin.svg';
import SkinBlue from '../images/Skin-blue.svg';
import ReactGA from "react-ga4";

// import Background from '../images/Background.svg';



export default function SkinCloseBar(props){

    const [clickMode, setClickMode ] = useState(false)
   
    const onMouseDownHandler = () => {
        setClickMode(true);
        // console.log("onMouseDown Event!");
    };

    const onMouseUpHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
    };

    const onMouseLeaveHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
    };
    
    return(
        <div>
            <div className="skin-item"  >
                <img src={(clickMode == true)? props.getSkinBlue(props.skinIds[0]) :props.getSkin(props.skinIds[0])} 
                    onClick={ReactGA.event({category: 'Engagement',action: "ui_texture_default",value: 1})}
                    onMouseDown={onMouseDownHandler}
                    onMouseUp={onMouseUpHandler}
                    onMouseLeave={onMouseLeaveHandler}
                    onTouchMove={onMouseLeaveHandler}
                    onTouchCancel={onMouseLeaveHandler}
                    onTouchStart={onMouseDownHandler}
                    onTouchEnd={onMouseUpHandler}
                    alt="Logo" 
                    className="skin--icon"

                />
            </div>
    
        </div>

    )         
}